import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import Home from "./components/user/Home";
import UserProtected from "./components/UserProtected";
import AuthProtect from "./components/auth/AuthProtect";
// admin routes
import ContactList from "./components/admin/ContactList";
const App = () => {
  return (
    <Routes>
      <Route element={<AuthProtect />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>
      <Route element={<UserProtected />}>
        <Route path="/" element={<Home />} />
      </Route>
      <Route path="/admin" element={<ContactList />} />
    </Routes>
  );
};

export default App;
